var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutCrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_16070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6168 61.7751H9.39091C7.12659 61.7751 4.95501 60.8756 3.35389 59.2745C1.75277 57.6733 0.853271 55.5018 0.853271 53.2374L0.853271 6.52515L17.9286 23.6004L35.0038 6.52515L52.0791 23.6004L69.1544 6.52515V53.2374C69.1544 55.5018 68.2549 57.6733 66.6538 59.2745C65.0527 60.8756 62.8811 61.7751 60.6168 61.7751ZM6.54503 20.2651V53.2374C6.54503 53.9922 6.84487 54.7161 7.37857 55.2498C7.91228 55.7835 8.63614 56.0833 9.39091 56.0833H60.6168C61.3715 56.0833 62.0954 55.7835 62.6291 55.2498C63.1628 54.7161 63.4626 53.9922 63.4626 53.2374V20.2651L52.0791 31.6486L35.0038 14.5733L17.9286 31.6486L6.54503 20.2651Z",
    fill: "#183883"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_16070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.3011,
    height: 68.3011,
    fill: "white",
    transform: "translate(0.853271)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCrown);
export default __webpack_public_path__ + "static/media/About-crown.9c7f9941427489ec0840651486fbdc12.svg";
export { ForwardRef as ReactComponent };